import { GetLevelModel } from "@factory/model/query-model-level";

import { levelFormDefault } from "./form.default";
import { LevelFormSchema } from "./form.rule";

export const useFormDefaultLevel = () => {
  const getDefault = (cachedValue: GetLevelModel | undefined) => {
    return !cachedValue
      ? levelFormDefault
      : ({
          tenant: cachedValue.tenant,
          name: cachedValue.name,
          description: cachedValue.description,
          avatar: cachedValue.avatar,
          points: cachedValue.points,
          stamp: cachedValue.stamp,
          constraint: cachedValue.constraint,
          maxStamp: cachedValue.max_stamp,
          maxPoints: cachedValue.max_points,
          maxStampPerDay: cachedValue.max_stamp_per_day,
          maxPointsPerDay: cachedValue.max_points_per_day,
        } as LevelFormSchema);
  };

  return {
    getDefault,
  };
};
